import { LinkObject } from '@Models/types';

interface Props {
  links: LinkObject[];
}

const Links: React.FC<Props> = ({ links }) => {
  return (
    <div className="flex flex-col">
      <div className="mt-1 flex flex-row items-center text-xl font-bold text-primary-700">
        <label>TestRail Links</label>
      </div>
      <div className="custom-scroll mb-5 flex flex-grow flex-col gap-y-2 overflow-y-auto p-4">
        {links.map((tr, index) => (
          <div
            data-testid="test-link-item"
            key={index}
            className="flex flex-col py-1"
          >
            <label className="font-medium text-primary-700">{tr.name}</label>

            {tr.Test_Rail.map((item, index) => (
              <div
                key={index}
                className="flex w-full flex-row items-center gap-x-2 p-1 text-xs"
              >
                <label className="w-1/2">{item.title}</label>
                <a href={item.link} className="w-1/2 text-primary-500">
                  {item.link}
                </a>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Links;
